module.exports = __webpack_public_path__ + "static/media/Golos_Text_Regular.880220dc.woff";